import React from "react";
import UserInfo from "../../pages/User/user";
import Security from "../../pages/User/security";

const userRoutes = [
  {
    path: "user",
    element: <UserInfo />,
  },
  {
    path: "security",
    element: <Security />,
  },
];

export default userRoutes;
